module.exports = __webpack_public_path__ + "img/IMG_5889.b7bbb8a2.jpg";